import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import { isAuthenticated } from './services/auth';
import { setNavigate } from './services/api';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';

const AppContent = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  return (
    <Routes>
      <Route path="/login" element={isLoggedIn ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />} />
      <Route path="/register" element={<Register />} />

      {/* Clean Top-Level Individual Pages */}
      <Route path="/" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/users" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/merchants" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/shops" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/categories" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/bookings" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/hotspots" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/test-accounts" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/logs" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
      <Route path="/system-logs" element={<Navigate to="/logs" replace />} />

      {/* Backward-compatibility for old /dashboard paths */}
      <Route path="/dashboard" element={<Navigate to="/" replace />} />
      <Route path="/dashboard/users" element={<Navigate to="/users" replace />} />
      <Route path="/dashboard/merchants" element={<Navigate to="/merchants" replace />} />
      <Route path="/dashboard/shops" element={<Navigate to="/shops" replace />} />
      <Route path="/dashboard/categories" element={<Navigate to="/categories" replace />} />
      <Route path="/dashboard/bookings" element={<Navigate to="/bookings" replace />} />
      <Route path="/dashboard/hotspots" element={<Navigate to="/hotspots" replace />} />
      <Route path="/dashboard/test-accounts" element={<Navigate to="/test-accounts" replace />} />
      <Route path="/dashboard/logs" element={<Navigate to="/logs" replace />} />
      <Route path="/dashboard/*" element={<Navigate to="/" replace />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to={isLoggedIn ? "/" : "/login"} replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router basename={process.env.PUBLIC_URL}>
          <AppContent />
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
